module.exports = __webpack_public_path__ + "static/media/astro_running.b3496db7.png";